import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seminars-workshops',
  templateUrl: './seminars-workshops.component.html',
  styleUrls: ['./seminars-workshops.component.scss']
})
export class SeminarsWorkshopsComponent implements OnInit {

  selectedYear: string = '2023-24';

  seminarImages = [
    '/assets/img/quick-links/seminars/1 (1).jpg',
    '/assets/img/quick-links/seminars/1 (2).jpg',
    '/assets/img/quick-links/seminars/1 (3).jpg',
    '/assets/img/quick-links/seminars/1 (4).jpg',
    '/assets/img/quick-links/seminars/1 (5).jpg',
    '/assets/img/quick-links/seminars/1 (6).jpg',
    '/assets/img/quick-links/seminars/1 (7).jpg',
    '/assets/img/quick-links/seminars/1 (8).jpg',
    '/assets/img/quick-links/seminars/1 (9).jpg',
  ];

  constructor() { }

  ngOnInit(): void { }

  getPdfPath(): string {
    if (this.selectedYear === '2023-24') {
      return '/assets/pdf/iqac/Seminars-and-Workshops-2023-24.pdf';
    } else if (this.selectedYear === '2022-23') {
      return '/assets/pdf/iqac/Seminar-and-Workshops-2022-23.pdf';
    } else {
      return '/assets/pdf/iqac/Seminars-and-Workshops-2021-22.pdf';
    }
  }

}
